import { useRouter } from 'next/router';
import { useEffect } from 'react';

function QueueFair() {
  const router = useRouter();
  const isLastPage = router.pathname === '/success';

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (isLastPage) {
      const getSystemName = (partial) => {
        const founded = getCookiesByPartialName(partial);

        const name = Object.keys(founded)[0];
        if (!name) return '';
        return name.replace(partial, '');
      };
      const SYSTEM_NAME = getSystemName(
        process.env.NEXT_PUBLIC_QUEUE_SYSTEM_PARTIAL,
      );

      let accName = process.env.NEXT_PUBLIC_ACCOUNT_SYSTEM_NAME;
      let qName = SYSTEM_NAME;

      function getCookie(cname) {
        let name = cname + '=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return '';
      }
      let cName = 'QueueFair-Pass-' + qName;
      let oldVal = getCookie(cName);

      if (oldVal != '') {
        document.cookie =
          cName + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        const img = document.createElement('img');
        img.width = '1';
        img.height = '1';
        img.src = `https://${accName}.queue-fair.net/clear/${qName}?val=${encodeURIComponent(
          oldVal,
        )} style="display:none"`;
        document.body.appendChild(img);
      }

      function sa(type) {
        let s;
        try {
          s = window[type];
          let x = '__storage_test__';
          s.setItem(x, x);
          s.removeItem(x);
          return true;
        } catch (e) {
          return (
            e instanceof DOMException &&
            (e.code === 22 ||
              e.code === 1014 ||
              e.name === 'QuotaExceededError' ||
              e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            s &&
            s.length !== 0
          );
        }
      }
      if (sa('localStorage')) {
        localStorage.removeItem(cName);
        localStorage.removeItem('QFEXP' + cName);
      }
      return;
    }
    const existingScript = document.querySelector(
      'script[src="https://files.queue-fair.net/queue-fair-adapter.js"]',
    );

    if (existingScript) return; // Ya existe, no hacer nada

    const script = document.createElement('script');
    script.src = 'https://files.queue-fair.net/queue-fair-adapter.js';
    script.setAttribute('data-queue-fair-client', 'boletia');
    script.async = true;

    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [isLastPage]);
}

export default QueueFair;

function getCookiesByPartialName(partialName) {
  const cookies = document.cookie.split(';');
  const matchingCookies = {};

  cookies.forEach((cookie) => {
    const [name, value] = cookie.trim().split('=');
    if (name.includes(partialName)) {
      // También puedes usar `name.startsWith()` o `name.match(/regex/)`
      matchingCookies[name] = decodeURIComponent(value);
    }
  });

  return matchingCookies; // Retorna un objeto con las cookies que coinciden
}
